import { Injectable, Injector, NgZone } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector, // Avoids cyclic dependency
    private ngZone: NgZone // Runs Snackbar in Angular zone
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log('HTTP Interceptor:', req.method, req.url);
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // console.log('HTTP Error:', error);
        // Log error for debugging
        console.error('HTTP Error:', {
          status: error.status,
          message: error.message,
          body: error.error,
        });

        let status = error.status;
        let errorMessage = 'An unexpected error occurred';
        
        // Check if it's a client-side error first
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `Client error: ${error.error.message}`;
        } else if (status === 0) {
          // Network error
          errorMessage = 'Server is offline. Please try again later.';
        } else {
          // Server-side error
          if (error.error) {
            if (typeof error.error === 'string') {
              errorMessage = error.error;
            } else if (error.error.message) {
              errorMessage = error.error.message;
            }
            status = error.error.status || error.status;
          }
          errorMessage = `Server error: ${status}: ${errorMessage}`;
        }

        // Optionally display error feedback in the UI (e.g., toast notifications)
        this.displayErrorFeedback(errorMessage);

        // Re-throw the error for further handling in services or components
        return throwError(
          () => new Error(errorMessage, { cause: error.error || error })
        );
      })
    );
  }

  private displayErrorFeedback(errorMessage: string): void {
    // Lazy load MatSnackBar to prevent circular dependencies
    const snackBar = this.injector.get(MatSnackBar);

    // Run inside Angular zone to update UI
    this.ngZone.run(() => {
      console.error('Global Error:', errorMessage); // Log error in the console
      snackBar.open(errorMessage, 'Dismiss', {
        duration: 10000,
        panelClass: ['error-snackbar'], // Optional custom styling
      });
    });
  }
}
